import { Component, Input } from '@angular/core';

@Component({
  selector: 'piqet-angular-environmental-savings',
  templateUrl: './environmental-savings.component.html',
  styleUrls: ['./environmental-savings.component.scss'],
})
export class EnvironmentalSavingsComponent {
  environmental_savings = '7030 t CO2-eq';
  @Input() environmentSavingData: any;
}
